export default "__VITE_ASSET__BTgR_t0B__"